import React, { useEffect, useState } from 'react'
import { Placeholder } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import useMountEffect from '../../../hooks/useMountEffect'
import styles from './styles.scss'
import { getListingImageUrl } from '../../../utils/listing'
const cx = classnames.bind(styles)

/**
 * Optionally pass a listing or a url.  Listing will take precedence.
 */
const ListingImage = ({
  listing = {},
  url = '',
  encode = true,
  alt = 'Listing Image',
  rounded = true,
  className = '',
  elmId,
  loading = false, // probably won't be used much in practice but helps emulate server side situation (no default img)
  featureFlags,
}) => {
  const getValidImageUrl = url => {
    if (loading) return ''
    const encodedUrl = encode ? encodeURI(url) : url
    return getListingImageUrl(encodedUrl, featureFlags)
  }

  const [imgUrl, setImgUrl] = useState(listing.primary_photo || url)

  useMountEffect(() =>
    setImgUrl(getValidImageUrl(listing.primary_photo || url))
  )

  useEffect(
    () => setImgUrl(getValidImageUrl(listing.primary_photo || url)),
    [listing.primary_photo || url, loading]
  )

  const onError = () => {
    setImgUrl(getListingImageUrl())
  }

  return !imgUrl ? (
    <div className={cx('placeholder-container')}>
      <Placeholder
        className={cx('placeholder', className, rounded && 'border-radius')}
      />
    </div>
  ) : (
    <img
      className={cx('image', className, rounded && 'border-radius')}
      src={imgUrl}
      alt={alt}
      onError={onError}
      data-elm-id={elmId}
    />
  )
}

ListingImage.propTypes = {
  listing: PropTypes.object,
  featureFlags: PropTypes.object,
  url: PropTypes.string,
  encode: PropTypes.bool,
  alt: PropTypes.string,
  rounded: PropTypes.bool,
  className: PropTypes.string,
  elmId: PropTypes.string,
  loading: PropTypes.bool,
}

export default ListingImage
